import { useLocalStoreData, useCrudAction } from 'stores/hooks';
import {
  createMeetingAsync,
  getCreateMeetingRequestStatus,
  getMeetingsListRequestStatus,
  getMeetingsList,
  getMeetingsAsync,
} from './meetingsSlice';

export function useCreateMeeting() {
  return useCrudAction({
    thunk: createMeetingAsync,
    requestStatusGetter: getCreateMeetingRequestStatus,
  });
}

export function useMeetingList(params?: URLSearchParams) {
  return useLocalStoreData({
    dataGetter: getMeetingsList,
    requestStatusGetter: getMeetingsListRequestStatus,
    thunk: getMeetingsAsync,
    params,
  });
}
